var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgpage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 4009,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    fillRule: "nonzero",
    d: "M0 0H1600V4009H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.113 1543.143c98.252-119.333 272.014-173.918 521.286-163.754 72.909 2.973 111.875-20.504 130.833-51.052 10.652-17.164 20.17-107.441-4.165-117.944-24.337-10.503-43.776 18.055-20.901 18.055 22.875 0-22.875-104.805-77.346-62.305m50.596 2017.728c-88.722-39.097-232.958-11.131-432.706 83.899-299.624 142.544-478.416-473.878-543.693-493.032-65.276-19.152-77.226 53.397-37.967 53.397 39.258 0 28.087-14.134 0-184.111-28.088-169.977 363.218-292.577 851.03-167.506 487.812 125.07 469.053-280.946 399.248-386.075-69.805-105.128 17.378-109.6 17.378-72.32 0 37.279-63.767 41.252-351.29 85.327-287.525 44.075-812.64-47.092-903.422-184.448-112.935-170.872-6.194-311.586 149.474-261.452 155.668 50.135 230.59-47.651 247.303-50.134 16.713-2.483 27.734 19.998 0 19.998-18.488 0-23.041-19.912-13.658-59.736l15.429-21.03 2.57-3.505m549.938-377.15c-14.593 11.768-30.561 17.652-47.904 17.652-26.013 0-209.673-55.077-226.832-105.301-17.158-50.225 5.348-67.963 32.61-75.39 27.262-7.429 40.922 25.232 27.283 37.728-13.639 12.496-21.617 16.65-35.838 20.222-14.22 3.573-145.828 28.532-78.369-69.035 44.973-65.044 155.544-118.087 331.715-159.129",
    stroke: "#FDB721",
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgpage);
export default __webpack_public_path__ + "static/media/bgpage.70f5e14fe360eed38ab6b7d4916606a6.svg";
export { ForwardRef as ReactComponent };